document.addEventListener('DOMContentLoaded',function(){
const update=root=>{
  const imgs=[...root.querySelectorAll('.product-block__image')];
  const dots=[...root.querySelectorAll('.product-block__image-dot')];
  if(!imgs.length||!dots.length)return;
  const total=imgs.length, dotCount=dots.length;
  const activeImgIndex=Math.max(0,imgs.findIndex(el=>el.classList.contains('product-block__image--active')));
  const norm=((activeImgIndex%total)+total)%total;
  let activeDotIndex=0;
  if(dotCount<5){ activeDotIndex=Math.min(norm,dotCount-1); }
  else { activeDotIndex = norm===0 ? 0 : (norm<4 ? norm : 4); }
  dots.forEach((el,i)=>el.classList.toggle('product-block__image-dot--active',i===activeDotIndex));
};
const cards=document.querySelectorAll('.product-grid .product-block');
const mo=new MutationObserver(muts=>{
  muts.forEach(m=>{
    const root=m.target.closest('.product-block');
    if(root)update(root);
  });
});
cards.forEach(card=>{
  mo.observe(card,{attributes:true,subtree:true,attributeFilter:['class']});
  update(card);
});
});